import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Naslovna from './Naslovna';
import ONama from './ONama';
import Repertoar from './Repertoar';
import Layout from './Layout';
import Galerija from './Galerija';

function App() {

  return (

<Router>
  <Routes>
  <Route path="/" element={<Layout><Naslovna /></Layout>} />
  <Route path="/o-nama" element={<Layout><ONama /></Layout>} />
  <Route path="/repertoar" element={<Layout><Repertoar /></Layout>} />
  <Route path="/galerija" element={<Layout><Galerija /></Layout>} />
</Routes>
</Router>
  )
}

 


export default App;
